import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import Box from "@mui/material/Box";

export const StyledWhiteContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    background: theme.customColors.white,
    borderRadius: "4px",
  };
});

export const StyledTableHeader = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    fontSize: "12px",
    fontWeight: 500,
    color: theme.customColors.black,
    lineHeight: "20px",
  };
});

export const StyledDetailHint = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    fontSize: "12px",
    fontWeight: 500,
    color: theme.customColors.purple[500],
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
  };
});
